module.exports = __webpack_public_path__ + "img/clint3.605a0c16.png";